import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import { withTranslation } from "react-i18next";

import { Link } from "react-router-dom";

import { Button, Card, Container, Row } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";

class DataEntryViewOutwardStok extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.products2 = [
      {
        id: "01",
        categories: "HPHT",
        weight: 1.50,
        pieces: 1,
        inward: "",
      },
      {
        id: "02",
        categories: "HPHT",
        weight: 1.50,
        pieces: 1,
        inward: "",
      },
      {
        id: "03",
        categories: "LPHT",
        weight: 1.50,
        pieces: 1,
        inward: "",
      },
      {
        id: "04",
        categories: "REAL",
        weight: 1.50,
        pieces: 1,
        inward: "",
      },
    ];
  }
  render() {

    this.columns2 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "categories",
        text: "Categories",
        footer: "",
      },
      {
        dataField: "weight",
        text: `${this.props.t('Weight / Carat')}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
      },
      {
        dataField: "inward",
        text: `${this.props.t('Inward Remarks')}`,
        footer: "",
      },
      {
        dataField: "outward",
        text: "Outward Remarks",
        footer: "",
      },
    ];
    document.title = "Data entry person";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Manage Stock - Outward Stock" />
            <Card className="px-lg-3 px-0 py-4">
              <div className="d-lg-flex d-block justify-content-between">
                <div>
                  <h4 className="pb-3 text-black fw-bold">
                    View Outward Stock
                  </h4>
                </div>
                {/* <div>
                  <label
                    htmlFor="date"
                    className="pe-2 fs-5 fw-bold text-black"
                  >
                    Date:
                  </label>
                  <input type="date" className="fs-5 border-0 text-black" />
                </div> */}
              </div>
              <Row>
                <form>
                  <div className="mb-3 row">
                    <label
                      htmlFor="example-text-input"
                      className="col-lg-2 col-12 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold"> {this.props.t('Stock ID')} </h5>
                    </label>
                    <div className="col-lg-7 col-12">
                      <select
                        className="form-select fs-5 text-secondary"
                        name="unitName"
                        disabled
                      >
                        <option value="" disabled>
                          select
                        </option>
                        <option value="xyz">STOCK0000123</option>
                        <option value="xyz">STOCK0000123</option>
                        <option value="xyz">STOCK0000123</option>
                        <option value="xyz">STOCK0000123</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="example-text-input"
                      className="col-lg-2 col-12 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">{this.props.t('Party Code')}</h5>
                    </label>
                    <div className="col-lg-7 col-12">
                      <input
                        className="form-control fs-5"
                        type="text"
                        name="partyCode"
                        placeholder="XYZ Diamond"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-lg-2 col-12 col-form-label">
                      <h5 className="text-secondary fw-bold">{this.props.t('Unit Name')}</h5>
                    </label>
                    <div className="col-lg-7 col-12">
                      <select
                        className="form-select fs-5 text-secondary"
                        name="unitName"
                        disabled
                      >
                        <option value="" disabled>
                          select
                        </option>
                        <option value="xyz">ABC Diamond Unit</option>
                        <option value="xyz">ABC Diamond Unit</option>
                        <option value="xyz">ABC Diamond Unit</option>
                        <option value="xyz">ABC Diamond Unit</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="example-text-input"
                      className="col-lg-2 col-12 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">
                        {this.props.t('Total No of Pieces')}
                      </h5>
                    </label>
                    <div className="col-lg-7 col-12">
                      <input
                        className="form-control fs-5"
                        type="text"
                        name="pieces"
                        placeholder="01%"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="example-text-input"
                      className="col-lg-2 col-12 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">Total Weight</h5>
                    </label>
                    <div className="col-lg-7 col-12">
                      <input
                        className="form-control fs-5"
                        type="text"
                        name="weight"
                        placeholder="20.25 CT"
                        disabled
                      />
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="col-lg-2 col-12 col-form-label">
                      <h5 className="text-secondary fw-bold">
                        {this.props.t("Grader Name")}
                      </h5>
                    </label>
                    <div className="col-lg-7 col-12">
                      <select
                        className="form-select fs-5 text-secondary"
                        name="graderName"
                        disabled
                      >
                        <option value="" disabled>
                          select
                        </option>
                        <option value="name1">Grader 1</option>
                        <option value="name2">Grader 2</option>
                        <option value="name3">Grader 3</option>
                        <option value="name4">Grader 4</option>
                      </select>
                    </div>
                  </div>

                  <div className="row px-3 pt-4">
                    <div>
                      <h3 className="fw-bold pb-3 text-black">
                        {this.props.t('Outward Stock Summary')}
                      </h3>
                    </div>

                    <div className="table-responsive">
                      <BootstrapTable
                        classes="foo"
                        keyField="id"
                        headerClasses="background-light fs-5"
                        footerClasses="background-light fs-5"
                        bootstrap4={true}
                        data={this.products2}
                        columns={this.columns2}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="example-text-input"
                      className="col-lg-2 col-12 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">Self Internal Remarks</h5>
                    </label>
                    <div className="col-lg-10 col-12">
                      <textarea
                        className="form-control fs-5"
                        type="text"
                        name="inward"
                        disabled
                        rows="5"
                      ></textarea>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="example-text-input"
                      className="col-lg-2 col-12 col-form-label"
                    >
                      <h5 className="text-secondary fw-bold">For Next Person Instruction</h5>
                    </label>
                    <div className="col-lg-10 col-12">
                      <textarea
                        className="form-control fs-5"
                        type="text"
                        name="outward"
                        disabled
                        rows="5"
                      ></textarea>
                    </div>
                  </div>

                  <div className="col-md-12 text-end">
                    <Link to="/data-entry-outward-stock-list">
                      {" "}
                      <Button
                        color="primary"
                        className="fs-4 px-5"
                        type="submit"
                      >
                        Back
                      </Button>
                    </Link>
                    <Button
                      onClick={e => window.print(e.preventDefault())}
                      color="success"
                      className="fs-4 ms-2"
                      type="submit"
                    >
                      <img
                        src="images/dashboard-images/printwhite.svg"
                        alt="print"
                      />
                    </Button>
                  </div>
                </form>
              </Row>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(DataEntryViewOutwardStok);
